import styled from 'styled-components';
import { Link } from '../../common/components/Link';
import { ThemeColours } from '../../common/styles/ThemeColours';
import { FontWeight, FONT_STACK, PRESSABLE } from '../../common/styles/constants';

export const StyledBar = styled.div`
  ${FONT_STACK};
  align-items: center;
  background-color: ${ThemeColours.warning};
  color: ${ThemeColours.warning700};
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  flex-wrap: wrap;
  font-size: 14px;
  font-weight: ${FontWeight.SEMI_BOLD};
  height: 60px;
  justify-content: space-evenly;
  width: 100%;
`;

export const RibbonText = styled.span`
  line-height: 1;
`;

export const RibbonLink = styled(Link)`
  ${PRESSABLE};
  color: ${ThemeColours.warning700};
  text-decoration: underline;
`;
